import { Pipe, PipeTransform } from '@angular/core';
import { Asset, AssetBuilder } from '@ddt-web/domain';


@Pipe({
	name: 'jsonToAsset'
})
export class JsonToAssetPipe implements PipeTransform {

	public transform(assetJson: any, args?: any): Asset {
		let hasErrors: boolean = false;

		let identifier: string = '';
		if (assetJson?.identifier) {
			identifier = assetJson.identifier;
		} else {
			identifier = '';
			hasErrors = true;
		}

		let identifierType: string = '';
		if (assetJson?.identifierType) {
			identifierType = assetJson.identifierType;
		} else {
			identifierType = '';
			hasErrors = true;
		}

		return new AssetBuilder()
			.setIdentifier(identifier)
			.setIdentifierType(identifierType)
			.setGlobalId(assetJson?.globalId)
			.setAladdinId(assetJson?.aladdinId)
			.setMorningstarSecId(assetJson?.morningstarSecId)
			.setCusip(assetJson?.cusip)
			.setTicker(assetJson?.ticker)
			.setAssetType(assetJson?.assetType)
			.setErroneous(hasErrors)
			.build();
	}
}
